import React from 'react'
import TextField from '@mui/material/TextField'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import CircularProgress from '@mui/material/CircularProgress';
import slugify from 'react-slugify';
import Session from '../shared/Session';
import SendIcon from '@mui/icons-material/Send';
import LoadingButton from '@mui/lab/LoadingButton';
import Stack from '@mui/material/Stack';
import { MenuItem, Select, InputLabel } from '@mui/material';
import Button from '@mui/material/Button';
import openapi_json from '../shared/openapi.json';

export default class OpenApiFormGenerator extends React.Component<any, any> {
    openapi: any = openapi_json;
    method: string = this.props.method.toLowerCase();
    path = this.props.path.toLowerCase();
    route: any = this.openapi.paths[this.path][this.method];
    schemaName = this.props.path.split("/")[1].slice(0, -1);
    body_schema: any = undefined;
    multipart_schema: any = undefined;
    editAllFields: boolean = this.props.editAllFields || false;
    default_values: any = {};
    editingSchema: any = undefined;

    constructor(props: any) {
        super(props);
        
        if (this.route.parameters !== undefined) {
            for (let i = 0; i < this.route.parameters.length; i++) {
                let parameter = this.route.parameters[i];
                if (!(parameter.name in this.default_values)) {
                    if(parameter.schema.default !== undefined){
                        this.default_values[parameter.name] = parameter.schema.default;
                    }else if (parameter.schema.type === "boolean") {
                        this.default_values[parameter.name] = false;
                    } else if (parameter.schema.type === "object") {
                        this.default_values[parameter.name] = "{}";
                    } else if (parameter.schema.type === "integer") {
                        this.default_values[parameter.name] = 0;
                    }else{
                        this.default_values[parameter.name] = "";
                    }
                }
            }
        }

        if (this.route.requestBody !== undefined &&
            this.route.requestBody.content !== undefined &&
            this.route.requestBody.content["application/json"] !== undefined &&
            this.route.requestBody.content["application/json"].schema !== undefined &&
            this.route.requestBody.content["application/json"].schema["$ref"] !== undefined) {
            let ref = this.route.requestBody.content["application/json"].schema["$ref"].split("/");
            ref = ref[ref.length - 1];
            this.body_schema = this.openapi.components.schemas[ref];

            // console.log(this.body_schema.properties);
            for (const key in this.body_schema.properties) {
                if (!(key in this.default_values)) {
                    let types = [];
                    if (this.body_schema.properties[key].type) {
                        types.push(this.body_schema.properties[key].type);
                    }
                    if (this.body_schema.properties[key].anyOf) {
                        for (const anyOf of this.body_schema.properties[key].anyOf) {
                            types.push(anyOf.type);
                        }
                    }
                    if("default" in this.body_schema.properties[key]){
                        if(types.includes("object")){
                            this.default_values[key] = JSON.stringify(this.body_schema.properties[key].default, undefined, 4);
                        }else{
                            this.default_values[key] = this.body_schema.properties[key].default.toString();
                        }
                    } else {
                        if(types.includes("boolean")){
                            this.default_values[key] = false;
                        }else if(types.includes("object")){
                            this.default_values[key] = "{}";
                        }else if(types.includes("integer")){
                            this.default_values[key] = "0";
                        }else{
                            this.default_values[key] = "";
                        }
                    }
                }
            }
        }

        if (this.route.requestBody !== undefined &&
            this.route.requestBody.content !== undefined &&
            this.route.requestBody.content["multipart/form-data"] !== undefined &&
            this.route.requestBody.content["multipart/form-data"].schema !== undefined &&
            this.route.requestBody.content["multipart/form-data"].schema["$ref"] !== undefined) {
            let ref = this.route.requestBody.content["multipart/form-data"].schema["$ref"].split("/");
            ref = ref[ref.length - 1];

            this.multipart_schema = this.openapi.components.schemas[ref];

            console.log(this.multipart_schema);
            for (const key in this.multipart_schema.properties) {
                if (!(key in this.default_values)) {
                    if("default" in this.multipart_schema.properties[key]){
                        this.default_values[key] = this.multipart_schema.properties[key].default;
                    } else {
                        if(this.multipart_schema.properties[key]["type"] === "string" && this.multipart_schema.properties[key]["format"] === "binary"){
                            console.log(`Found binary file ${key}`);
                            this.default_values[key] = "";
                        }else{
                            console.log(`Unknown multipart schema type for ${key}: ${this.multipart_schema.properties[key].type}`);
                        }
                    }
                }
            }
        }

        if ("id" in this.props && this.props.id !== undefined) {
            this.default_values[this.schemaName + "_id"] = this.props.id;
            if (this.editingSchema === undefined) {
                Session.api("GET", "/" + this.props.path.split("/")[1] + "/" + this.props.id + "?hydrated=true", {}, (result: any) => {
                    if (this.body_schema !== null) {
                        for (const key in this.body_schema.properties) {
                            if (key in result) {
                                if(typeof result[key] === "object" && result[key] !== null){
                                    this.default_values[key] = JSON.stringify(result[key], undefined, 4);
                                }else{
                                    this.default_values[key] = result[key] || "";
                                }
                            }
                        }
                    }
                    this.editingSchema = result;
                    this.forceUpdate();
                });
            }
        }

        this.state = {
            body: "",
            loading: false,
        };

        if (typeof(this.body_schema) !== "undefined" && this.body_schema !== null) {
            if ("organization_id" in this.body_schema.properties) {
                Session.api("GET", "/organizations/", {}, (result: any) => {
                    Session.organizations = result;
                });
            } else if ("provider_id" in this.body_schema.properties) {
                Session.api("GET", "/providers/", {}, (result: any) => {
                    Session.providers = result;
                });
            } else if ("deployment_id" in this.body_schema.properties) {
                Session.api("GET", "/deployments/", {}, (result: any) => {
                    Session.deployments = result;
                });
            } else if ("application_id" in this.body_schema.properties) {
                Session.api("GET", "/applications/", {}, (result: any) => {
                    Session.applications = result;
                });
            } else if ("function" in this.body_schema.properties) {
                Session.api("GET", "/tasks/functions", {}, (result: any) => {
                    Session.taskFunctions = result;
                });
            }
        }
    }

    handleInputChange = (event: any, key: string, checked: boolean = false) => {
        if (checked) {
            this.setState({
                [key]: event.target.checked
            });
        } else if (key === "file"){
            console.log(`Selected file:`);
            console.log(key);
            console.log(event.target.files[0]);
            this.setState({
                [key]: event.target.files[0]
            });
        } else {
            this.setState({
                [key]: event.target.value
            });
            if (key === "function" && "parameters" in this.body_schema.properties) {
                for (const func of Session.taskFunctions) {
                    if (func.name === event.target.value) {
                        var default_parameters: Record<string, string> = {};
                        for (const param of func.parameters) {
                            default_parameters[param] = "";
                        }
                        this.default_values["parameters"] = JSON.stringify(default_parameters, undefined, 4);
                        break;
                    }
                }
            }
        }
    };

    buildInputForParameter = (route_key: string, parameter: any, disabled: boolean) => {
        if (parameter.name === "authorization") {
            return;
        }
    
        let type = "text";
        let label = parameter.name;
        let required = false;
        let html_key = route_key + "-" + label;
    
        if (parameter.schema.type !== undefined) {
            type = parameter.schema.type;
        }
        if (parameter.schema.title !== undefined) {
            label = parameter.schema.title;
        }
    
        if (type === "boolean") {
            return <FormControl key={html_key + "-formcontrol"}>
                <FormControlLabel
                    key={html_key + "-formcontrollabel"}
                    id={html_key + "-formcontrollabel"}
                    control={<Checkbox 
                        key={html_key + "-checkbox"}
                        id={html_key + "-checkbox"}
                        color="default"
                        size="medium"
                        value={this.state[parameter.name] || this.default_values[parameter.name]}
                        onChange={(e) => { this.handleInputChange(e, parameter.name, true); }}
                    />}
                    label={label}
                />
            </FormControl >
        }
    
        if (parameter.required !== undefined) {
            required = parameter.required;
        }
    
        if (type === "object") {
            return <FormControl key={html_key + "-formcontrol"}>
                <TextField
                    key={html_key + "-textfield"}
                    id={html_key + "-textfield"}
                    type="text"
                    multiline
                    required={required ? true : undefined}
                    value={this.state[parameter.name] || this.default_values[parameter.name]}
                    helperText={label}
                    variant="standard"
                    size="medium"
                    onChange={(e) => { this.handleInputChange(e, parameter.name); }}
                />
            </FormControl>
        }
    
        if (type === "integer") {
            type = "number";
        }
    
        return <FormControl key={html_key + "-formcontrol"}>
            <TextField
                key={html_key + "-textfield"}
                id={html_key + "-textfield"}
                type={type}
                required={required ? true : undefined}
                value={this.state[parameter.name] || this.default_values[parameter.name]}
                disabled={disabled}
                helperText={label}
                variant="standard"
                size="medium"
                onChange={(e) => { this.handleInputChange(e, parameter.name); }}
            />
        </FormControl>
    };

    buildInputForSchemaProperty = (route_key: string, schema: any, key: string) => {
        let type = "text";
        let label = schema.properties[key].title;
        let required = false;
        let html_key = route_key + "-" + key;
    
        if (schema.required !== undefined && schema.required.indexOf(key) > -1) {
            required = true;
        }

        let types = [];
        if (schema.properties[key].type) {
            types.push(schema.properties[key].type);
        }
        if (schema.properties[key].anyOf) {
            for (const anyOf of schema.properties[key].anyOf) {
                types.push(anyOf.type);
            }
        }
    
        if (types.includes("boolean")) {
            const checked = (this.state[key] && this.state[key] === true) || (this.state[key] === undefined && this.default_values[key] && this.default_values[key] === true);
                
            return <FormControl key={html_key + "-formcontrol"}>
                <FormControlLabel
                    key={html_key + "-label"}
                    id={html_key + "-label"}
                    control={<Checkbox
                        key={html_key + "-checkbox"}
                        id={html_key + "-checkbox"}
                        color="default"
                        size="medium"
                        checked={checked}
                        onChange={(e) => { this.handleInputChange(e, key, true); }}
                    />}
                    label={label}
                />
            </FormControl>
        }
    
        if (types.includes("object")) {
            let error = false;
            // https://stackoverflow.com/questions/4253367/how-to-escape-a-json-string-containing-newline-characters-using-javascript
            // let escaped_json_string = this.property_values[key].replace(/\n/g, "\\n");

            let clean_json = this.cleanJson(JSON.stringify(this.state[key] || this.default_values[key], undefined, 4));
            try {
                JSON.parse(clean_json);
            } catch (e) {
                console.log("------------------------------------------------------------------------");
                console.log(e);
                console.log(key);
                console.log(label);
                console.log(html_key);
                console.log(this.state[key]);
                console.log(clean_json);
                console.log("------------------------------------------------------------------------");
                error = true;
            }

            return <FormControl key={html_key + "-formcontrol"}>
                <TextField
                    key={html_key + "-textfield"}
                    id={html_key + "-textfield"}
                    type="text"
                    multiline
                    minRows={5}
                    required={required ? true : undefined}
                    value={this.state[key] || this.default_values[key]}
                    helperText={label + " (JSON)"}
                    error={error}
                    variant="standard"
                    size="medium"
                    onChange={(e) => { this.handleInputChange(e, key); }}
                />
            </FormControl>
        }
    
        if (types.includes("integer")) {
            type = "number";
        }
    
        if (key === "organization_id" || key === "provider_id" || key === "deployment_id" || key === "application_id" || key === "function") {
            let options = [];
            if (key === "organization_id") {
                for (const organization of Session.organizations) {
                    options.push(<MenuItem key={html_key + "-organization-" + organization.id} value={organization.id}>{organization.name}</MenuItem>);
                }
            } else if (key === "provider_id") {
                for (const provider of Session.providers) {
                    options.push(<MenuItem key={html_key + "-provider-" + provider.id} value={provider.id}>{provider.name}</MenuItem>);
                }
            } else if (key === "deployment_id") {
                for (const deployment of Session.deployments) {
                    options.push(<MenuItem key={html_key + "-provider-" + deployment.id} value={deployment.id}>{deployment.name}</MenuItem>);
                }
            } else if (key === "application_id") {
                for (const application of Session.applications) {
                    options.push(<MenuItem key={html_key + "-provider-" + application.id} value={application.id}>{application.name}</MenuItem>);
                }
            } else if (key === "function") {
                for (const func of Session.taskFunctions) {
                    options.push(<MenuItem key={html_key + "-function-" + func.name} value={func.name}>{func.title}</MenuItem>);
                }
            }
            return <FormControl key={html_key + "-formcontrol"}>
                <InputLabel key={html_key + "-input-label"} id={key + "-input-label"}>{label}</InputLabel>
                <Select
                    key={html_key + "-select"}
                    labelId={key + "-input-label"}
                    id={html_key + "-select"}
                    value={this.state[key] || this.default_values[key]}
                    label={label}
                    onChange={(e) => this.handleInputChange(e, key) }
                >
                    {options}
                </Select>
            </FormControl>
        }
    
        return <FormControl key={html_key + "-formcontrol"}>
            <TextField
                key={html_key + "-textfield"}
                id={html_key + "-textfield"}
                type={type}
                required={required ? true : undefined}
                value={this.state[key] || this.default_values[key]}
                helperText={label}
                variant="standard"
                size="medium"
                onChange={(e) => { this.handleInputChange(e, key); }}
            />
        </FormControl>
    };

    cleanJson = (json_string: string) => {
        if (!json_string) {
            return "";
        }
        let inside_string = false;
        let result = "";
        for (let i = 0; i < json_string.length; i++) {
            if (json_string[i] === '"') {
                inside_string = !inside_string;
                result += json_string[i];
            }else if (inside_string && json_string[i] === "\n") {
                result += "\\n";
            }else if (!inside_string && result[i] === "\n") {
                // pass
            }else {
                result += json_string[i];
            }
        }
        return result;
    };

    render() {
        if (this.openapi.paths[this.path] === undefined) {
            return <p>Missing OpenAPI Path: {this.path}</p>;
        }

        if (this.openapi.paths[this.path][this.method] === undefined) {
            return <p>Missing OpenAPI Method: {this.method} {this.path}</p>;
        }

        let route_key = this.method + "-" + slugify(this.path)
        let inputs = [];
        
        if (this.route.parameters !== undefined) {
            for (let i = 0; i < this.route.parameters.length; i++) {
                let parameter = this.route.parameters[i];
                let disabled = false;
                if (!this.editAllFields && ((this.schemaName + "_id") in this.state || (this.schemaName + "_id") in this.default_values)) {
                    disabled = true;
                }
                inputs.push(this.buildInputForParameter(route_key, parameter, disabled));
            }
        }

        if ((this.method === "post" || this.method === "put") && this.body_schema === null) {
            inputs.push(
                <FormControl key={route_key + "-body-formcontrol"}>
                    <TextField
                        key={route_key + "-body-textfield"}
                        id={route_key + "-body-textfield"}
                        type="text"
                        label="Body"
                        required={false}
                        minRows={3}
                        defaultValue={""}
                        helperText="Optional request body"
                        variant="standard"
                        size="medium"
                        onChange={(e) => { this.handleInputChange(e, "body"); }}
                    />
                </FormControl>
            );
        }

        if (this.body_schema !== undefined && this.body_schema !== null) {
            if (this.body_schema?.properties !== undefined) {
                for (const key in this.body_schema?.properties) {
                    inputs.push(this.buildInputForSchemaProperty(route_key, this.body_schema, key));
                }
            }
        }

        if (this.multipart_schema !== undefined && this.multipart_schema !== null) {
            if (this.multipart_schema?.properties !== undefined) {
                for (const key in this.multipart_schema?.properties) {
                    if(this.multipart_schema.properties[key].type === "string" && this.multipart_schema.properties[key].format === "binary"){
                        let required = false;
                        if (this.multipart_schema.required !== undefined && this.multipart_schema.required.indexOf(key) > -1) {
                            required = true;
                        }
                        let html_key = route_key + "-" + key;
                        inputs.push(
                            <FormControl key={html_key + "-formcontrol"}>
                                <TextField
                                    key={html_key + "-upload"}
                                    id={html_key + "-upload"}
                                    type="file"
                                    label={this.multipart_schema.properties[key].title}
                                    required={required}
                                    variant="standard"
                                    size="medium"
                                    onChange={(e) => { this.handleInputChange(e, key); }}
                                />
                            </FormControl>);
                    }else{
                        console.log(`Skipping input for multipart schema type ${key}: ${this.multipart_schema.properties[key].type}`);
                    }
                }
            }
        }

        // for (const key in this.body_schema.properties) {
        //     if(this.body_schema.properties[key].type === "object"){
        //         try {
        //             JSON.parse(this.cleanJson(this.state[key] || this.default_values[key]));
        //         } catch (e) {
        //             Session.app.setState({
        //                 snackbarOpen: true,
        //                 snackbarSeverity: "error",
        //                 message: e
        //             });
        //             break;
        //         }
        //     }
        // }

        return (
            <>
            {("/" + this.schemaName + "s/") in this.openapi.paths ? 
                <Button variant="contained" color="primary" style={{margin: "0.3%"}} onClick={() => {
                    Session.navigate("/data?view=" + this.schemaName + "s");
                }}>{this.schemaName} Data</Button>
            : "" }
            <br/>
            <br/>
            {("id" in this.props && this.props.id !== undefined && this.editingSchema !== undefined) || this.props.id === undefined ?
                <form style={{ maxWidth: "480px" }}>
                    <Stack key={this.method + "-" + this.path + "-stack"} spacing={2}>
                        {inputs}
                        <LoadingButton key={this.method + "-" + this.path + "-loadingbutton"}
                            onClick={(e) => {
                                e.preventDefault();

                                let substituted_path = this.path;
                                let pathParameters = "";
                                
                                if (this.route.parameters !== undefined) {
                                    this.route.parameters.forEach((parameter: any) => {
                                        var tmp_value = this.state[parameter.name];
                                        if (parameter.name in this.default_values && tmp_value === undefined) {
                                            tmp_value = this.default_values[parameter.name];
                                        }
                                        if (parameter.in === "path") {
                                            substituted_path = substituted_path.replace("{" + parameter.name + "}", tmp_value);
                                        } else {
                                            if (pathParameters === ""){
                                                pathParameters = "?";
                                            }else{
                                                pathParameters += "&";
                                            }
                                            pathParameters += parameter.name + "=" + tmp_value;
                                        }
                                    });
                                }

                                let error = undefined;

                                let bodyPayload = this.state.body;
                                if (typeof(this.body_schema) !== "undefined" && this.body_schema !== null && this.body_schema.properties !== undefined) {
                                    bodyPayload = {};
                                    for (const key in this.body_schema.properties) {
                                        if(this.body_schema.properties[key].type === "object"){
                                            let clean_json = this.cleanJson(this.state[key] || this.default_values[key]);
                                            try {
                                            bodyPayload[key] = JSON.parse(clean_json);
                                            } catch (e) {
                                                error = e;
                                                break;
                                            }
                                        }else if(this.body_schema.properties[key].type === "boolean"){
                                            const evaluated_bool = (this.state[key] && this.state[key] === true) || (this.state[key] === undefined && this.default_values[key] && this.default_values[key] === true);
                                            bodyPayload[key] = evaluated_bool;
                                        }else{
                                            bodyPayload[key] = this.state[key] || this.default_values[key];
                                        }

                                        if (bodyPayload[key] === "") {
                                            delete bodyPayload[key];
                                        }
                                    }
                                }

                                let postRaw = false;
                                if (this.multipart_schema !== undefined && this.multipart_schema !== null && this.multipart_schema.properties !== undefined) {
                                    bodyPayload = new FormData();
                                    for (const key in this.multipart_schema.properties) {
                                        bodyPayload.append(key, this.state[key]);
                                    }
                                    postRaw = true;
                                }

                                if (error) {
                                    // Session.app.setState({
                                    //     snackbarOpen: true,
                                    //     snackbarSeverity: "error",
                                    //     message: error
                                    // });
                                    alert(error);
                                } else {
                                    Session.api(this.props.method, substituted_path + pathParameters, bodyPayload, this.props.setResult, null, postRaw);
                                }

                            }}
                            type="submit"
                            endIcon={<SendIcon key={this.method + "-" + this.path + "-sendicon"} />}
                            loading={this.state.loading}
                            loadingPosition="end"
                            size="large"
                            variant="contained"
                        >
                            Submit
                        </LoadingButton>
                    </Stack>
                </form>
            : <CircularProgress/>}
            </>
        );
    }
}
